import { Box, styled } from '@mui/material';

export const PageGradient = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  minHeight: '100vh',
  background: theme.palette.gradients.page,
  zIndex: -1,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '10%',
    left: '5%',
    width: '50%',
    height: '50%',
    background: 'radial-gradient(circle, rgba(0,102,255,0.03) 0%, rgba(0,102,255,0) 70%)',
    borderRadius: '50%',
    transform: 'translate(-10%, -10%)',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '10%',
    right: '5%',
    width: '45%',
    height: '45%',
    background: 'radial-gradient(circle, rgba(91,141,239,0.03) 0%, rgba(91,141,239,0) 70%)',
    borderRadius: '50%',
    transform: 'translate(10%, 10%)',
  },
})); 